import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: "all",
  sort: "",
};

const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    sortBlog: (state, action) => {
      state.sort = action.payload;
    },
    filterBlog: (state, action) => {
      state.filter = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { sortBlog, filterBlog } = filterSlice.actions;
